import axios from 'axios';
import { API_BASE_URL } from '@config';

// Action types
export const GET_CAMPAIGNS = 'GET_CAMPAIGNS';
export const GET_CAMPAIGN = 'GET_CAMPAIGN';
export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN';
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN';
export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';
export const GET_CAMPAIGN_PARTICIPANTS = 'GET_CAMPAIGN_PARTICIPANTS';
export const CAMPAIGN_ERROR = 'CAMPAIGN_ERROR';
export const CLEAR_CAMPAIGN_ERROR = 'CLEAR_CAMPAIGN_ERROR';

// Get all campaigns
export const getCampaigns = () => dispatch => {
	const request = axios.get(`${API_BASE_URL}/api/campaigns`);
	return request
		.then(res => {
			dispatch({
				type: GET_CAMPAIGNS,
				payload: res.data
			});
			return res.data;
		})
		.catch(error => {
			dispatch({
				type: CAMPAIGN_ERROR,
				payload: error.response?.data?.message || 'Failed to fetch campaigns'
			});
		});
};

// Get single campaign
export const getCampaign = id => dispatch => {
	const request = axios.get(`${API_BASE_URL}/api/campaigns/${id}`);
	return request
		.then(res => {
			dispatch({
				type: GET_CAMPAIGN,
				payload: res.data
			});
			return res.data;
		})
		.catch(error => {
			dispatch({
				type: CAMPAIGN_ERROR,
				payload: error.response?.data?.message || 'Failed to fetch campaign'
			});
		});
};

// Get campaign by slug (public endpoint, no auth required)
export const getCampaignBySlug = slug => dispatch => {
	const request = axios.get(`${API_BASE_URL}/api/campaigns/by-slug/${slug}`);
	return request
		.then(res => {
			dispatch({
				type: GET_CAMPAIGN,
				payload: res.data
			});
			return res.data;
		})
		.catch(error => {
			dispatch({
				type: CAMPAIGN_ERROR,
				payload: error.response?.data?.message || 'Campaign not found'
			});
			throw error;
		});
};

// Create new campaign
export const createCampaign = campaignData => dispatch => {
	const request = axios.post(`${API_BASE_URL}/api/campaigns`, campaignData);
	return request
		.then(res => {
			dispatch({
				type: CREATE_CAMPAIGN,
				payload: res.data
			});
			// Refresh campaigns list
			dispatch(getCampaigns());
			return res.data;
		})
		.catch(error => {
			dispatch({
				type: CAMPAIGN_ERROR,
				payload: error.response?.data?.message || 'Failed to create campaign'
			});
			throw error;
		});
};

// Update campaign
export const updateCampaign = (id, campaignData) => dispatch => {
	const request = axios.put(`${API_BASE_URL}/api/campaigns/${id}`, campaignData);
	return request
		.then(res => {
			dispatch({
				type: UPDATE_CAMPAIGN,
				payload: res.data
			});
			// Refresh campaigns list
			dispatch(getCampaigns());
			return res.data;
		})
		.catch(error => {
			dispatch({
				type: CAMPAIGN_ERROR,
				payload: error.response?.data?.message || 'Failed to update campaign'
			});
			throw error;
		});
};

// Delete campaign
export const deleteCampaign = id => dispatch => {
	const request = axios.delete(`${API_BASE_URL}/api/campaigns/${id}`);
	return request
		.then(res => {
			dispatch({
				type: DELETE_CAMPAIGN,
				payload: id
			});
			// Refresh campaigns list
			dispatch(getCampaigns());
			return res.data;
		})
		.catch(error => {
			dispatch({
				type: CAMPAIGN_ERROR,
				payload: error.response?.data?.message || 'Failed to delete campaign'
			});
			throw error;
		});
};

// Get campaign participants for reporting
export const getCampaignParticipants = id => dispatch => {
	const request = axios.get(`${API_BASE_URL}/api/auth/campaign/${id}/participants`);
	return request
		.then(res => {
			dispatch({
				type: GET_CAMPAIGN_PARTICIPANTS,
				payload: res.data
			});
			return res.data;
		})
		.catch(error => {
			dispatch({
				type: CAMPAIGN_ERROR,
				payload: error.response?.data?.message || 'Failed to fetch campaign participants'
			});
			throw error;
		});
};

// Clear error
export const clearCampaignError = () => ({
	type: CLEAR_CAMPAIGN_ERROR
});
